import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import { useAuth } from "../context/AuthContext";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match?.[1];

    if (!sessionId) { navigate("/auth", { replace: true }); return; }

    (async () => {
      try {
        const { data } = await api.post("/auth/session", { session_id: sessionId });
        setUser(data.user);
        // Clean the hash and go home
        window.history.replaceState(null, "", window.location.pathname);
        navigate("/", { replace: true, state: { user: data.user } });
      } catch {
        navigate("/auth", { replace: true });
      }
    })();
  }, [navigate, setUser]);

  return (
    <div className="min-h-[60vh] flex items-center justify-center">
      <div className="font-display text-2xl text-[var(--gu-muted)]">Bringing you in…</div>
    </div>
  );
}
